import {API_ROOT_URL} from 'envs/_current/config'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'
import {schema} from 'normalizr'
import {groupSchema} from './schema'

// ─── Schemas ──────────────────────────────────────────────────────────────────

export const devotionSchema = new schema.Entity(
    'devotions',
    {},
    {idAttribute: 'idname'}
)
export const devotionArraySchema = [devotionSchema]

export const devotionIntentionSchema = new schema.Entity(
    'devotion_intentions',
    {},
    {idAttribute: 'id'}
)

export const devotionChecklistSchema = new schema.Entity(
    'devotion_checklists',
    {},
    {idAttribute: 'id'}
)

export const devotionParticipantSchema = new schema.Entity(
    'devotion_participants',
    {},
    {idAttribute: 'id'}
)
export const devotionParticipantArraySchema = [devotionParticipantSchema]

export const devotionPracticeSchema = new schema.Entity(
    'devotion_practices',
    {},
    {idAttribute: 'id'}
)

export const devotionReminderSchema = new schema.Entity(
    'devotion_reminders',
    {},
    {idAttribute: 'id'}
)

// ─── Devotion CRUD ────────────────────────────────────────────────────────────

// GET devotions/fetch — public listing
export const devotion_fetch_Api = {
    backend: `Route::get('devotions/fetch', 'DevotionController@index');`,
    root: API_ROOT_URL,
    path: '/devotions/fetch',
    method: 'GET',
    paramsFields: ['prayer_form', 'diocese_id', 'keyword'],
    schema: devotionSchema,
    transform: createListTransform(devotionSchema),
}

export const devotion_getSuggestedItems_Api = {
    backend: `Route::get('devotions/fetch-suggested-items', 'DevotionController@getSuggestedItems');`,
    root: API_ROOT_URL,
    path: '/devotions/fetch-suggested-items',
    method: 'GET',
    paramsFields: ['prayer_form', 'diocese_id', 'keyword'],
    schema: devotionSchema,
    transform: createListTransform(devotionSchema),
}

// GET devotions/:id/get — chi tiết 1 devotion
export const devotion_get_Api = {
    backend: `Route::get('devotions/{id}/get', 'DevotionController@show');`,
    root: API_ROOT_URL,
    path: '/devotions/:id/get',
    method: 'GET',
    paramsFields: [],
    schema: devotionSchema,
    transform: createTransform(devotionSchema),
}

export const devotion_getPracticeStats_Api = {
    backend: `Route::get('devotions/{id}/practice-stats', 'DevotionController@getPracticeStats');`,
    root: API_ROOT_URL,
    path: '/devotions/:id/practice-stats',
    method: 'GET',
    paramsFields: [],
}


// GET devotions/groups/get-my — danh sách group (Nhóm/Hội đoàn triển khai) do chính user tạo, filter theo keyword
export const devotion_getMyOrganizerGroups_Api = {
    backend: `Route::get('devotions/groups/get-my', 'DevotionController@myOrganizerGroups');`,
    root: API_ROOT_URL,
    path: '/devotions/groups/get-my',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: groupSchema,
    transform: createListTransform(groupSchema),
}

// POST devotions/create
export const devotion_create_Api = {
    backend: `Route::post('devotions/create', 'DevotionController@store');`,
    root: API_ROOT_URL,
    path: '/devotions/create',
    method: 'POST',
    // paramsFields: [
    //     'title', 'idname', 'prayer_form', 'prayer_content',
    //     'description', 'cover_image', 'weekday',
    //     'start_date', 'end_date', 'daily_start_time', 'daily_end_time',
    //     'timezone', 'public', 'diocese_id', 'parish_id',
    // ],
    schema: devotionSchema,
    transform: createTransform(devotionSchema),
}

// POST devotions/:id/edit
export const devotion_edit_Api = {
    backend: `Route::post('devotions/{id}/edit', 'DevotionController@update');`,
    root: API_ROOT_URL,
    path: '/devotions/:id/edit',
    method: 'POST',
    // paramsFields: [
    //     'title', 'idname', 'prayer_form', 'prayer_content',
    //     'description', 'cover_image', 'weekday',
    //     'start_date', 'end_date', 'daily_start_time', 'daily_end_time',
    //     'timezone', 'public', 'active', 'diocese_id', 'parish_id',
    // ],
    schema: devotionSchema,
    transform: createTransform(devotionSchema),
}

// POST devotions/:id/delete
export const devotion_delete_Api = {
    backend: `Route::post('devotions/{id}/delete', 'DevotionController@destroy');`,
    root: API_ROOT_URL,
    path: '/devotions/:id/delete',
    method: 'POST',
    paramsFields: [],
    schema: devotionSchema,
    transform: createTransform(devotionSchema),
}

// ─── Participant ──────────────────────────────────────────────────────────────

// GET devotions/devotion-participant/get-following — danh sách mình đang tham gia
export const devotion_getFollowing_Api = {
    backend: `Route::get('devotions/devotion-participant/get-following', 'DevotionController@myDevotions');`,
    root: API_ROOT_URL,
    path: '/devotions/devotion-participant/get-following',
    method: 'GET',
    paramsFields: [],
    schema: devotionParticipantSchema,
    transform: createListTransform(devotionParticipantSchema),
}

export const devotion_getMyGroupDevotions_Api = {
    backend: `Route::get('devotions/gets-group-by-form', 'DevotionController@myGroupDevotions');`,
    root: API_ROOT_URL,
    path: '/devotions/gets-group-by-form',
    method: 'GET',
    paramsFields: []
}

// POST devotions/:id/join
export const devotion_join_Api = {
    backend: `Route::post('devotions/{id}/join', 'DevotionController@join');`,
    root: API_ROOT_URL,
    path: '/devotions/:id/join',
    method: 'POST',
    // paramsFields: [
    //     'timezone', 'reminder_time',
    //     'reminder_repeat_count', 'reminder_repeat_interval_min',
    //     'notification_enabled', 'share_activity',
    // ],
    schema: devotionParticipantSchema,
    transform: createTransform(devotionParticipantSchema),
}

// POST devotions/:id/leave
export const devotion_leave_Api = {
    backend: `Route::post('devotions/{id}/leave', 'DevotionController@leave');`,
    root: API_ROOT_URL,
    path: '/devotions/:id/leave',
    method: 'POST',
    paramsFields: [],
    schema: devotionParticipantSchema,
    transform: createTransform(devotionParticipantSchema),
}

// POST devotions/devotion-participant/:id/update
export const devotion_updateParticipant_Api = {
    backend: `Route::post('devotions/devotion-participant/{id}/update', 'DevotionController@updateParticipant');`,
    root: API_ROOT_URL,
    path: '/devotions/devotion-participant/:id/update',
    method: 'POST',
    // paramsFields: [
    //     'timezone', 'reminder_time',
    //     'reminder_repeat_count', 'reminder_repeat_interval_min',
    //     'notification_enabled', 'share_activity',
    // ],
    schema: devotionParticipantSchema,
    transform: createTransform(devotionParticipantSchema),
}

// ─── Practice ─────────────────────────────────────────────────────────────────

// POST devotions/devotion-participant/:id/record
// Body: { status: 1|9|-9, note? }
export const devotion_recordPractice_Api = {
    backend: `Route::post('devotions/devotion-participant/{id}/record', 'DevotionController@recordPractice');`,
    root: API_ROOT_URL,
    path: '/devotions/devotion-participant/:id/record',
    method: 'POST',
    // paramsFields: ['status', 'note'],
    schema: devotionPracticeSchema,
    transform: createTransform(devotionPracticeSchema),
}


// POST devotions/:id/record-for-me — {id} = devotion id/idname, auto-join ngầm nếu chưa tham gia
// rồi ghi nhận practice luôn trong 1 lần gọi. Dùng cho tab "Kinh phụng vụ" ở /liturgical-calendar
// (Kinh Sáng/Kinh Tối) - không cần biết group_member_id/đã join hay chưa như devotion_recordPractice_Api.
// Body: { status?: 1|9|-9, note? } - mặc định COMPLETED nếu không truyền status.
export const devotion_recordPracticeForMe_Api = {
    backend: `Route::post('devotions/{id}/record-for-me', 'DevotionController@recordPracticeForDevotion');`,
    root: API_ROOT_URL,
    path: '/devotions/:id/record-for-me',
    method: 'POST',
    schema: devotionPracticeSchema,
    transform: createTransform(devotionPracticeSchema),
}

export const devotion_recordPracticeByGroup_Api = {
    backend: `Route::post('devotions/devotion-group/{group}/record', 'DevotionController@recordPracticeByGroup');`,
    root: API_ROOT_URL,
    path: '/devotions/devotion-group/:group/record',
    method: 'POST',
}

// GET devotions/devotion-participant/:id/history
// devotion_id bắt buộc — 1 group_member_id giờ có thể dùng chung cho nhiều devotion (vd Kinh Sáng/
// Kinh Tối chung 1 group), không truyền sẽ không tách được lịch sử đúng devotion.
export const devotion_practiceHistory_Api = {
    backend: `Route::get('devotions/devotion-participant/{id}/history', 'DevotionController@practiceHistory');`,
    root: API_ROOT_URL,
    path: '/devotions/devotion-participant/:id/history',
    method: 'GET',
    paramsFields: ['devotion_id'],
    schema: devotionPracticeSchema,
    transform: createListTransform(devotionPracticeSchema),
}

// ─── Reminder ─────────────────────────────────────────────────────────────────

// GET devotions/:id/get-reminder — lấy reminder theo devotion_id
export const devotion_getReminder_Api = {
    backend: `Route::get('devotions/{id}/get-reminder', 'DevotionController@getReminder');`,
    root: API_ROOT_URL,
    path: '/devotions/:id/get-reminder',
    method: 'GET',
    paramsFields: [],
    schema: devotionReminderSchema,
    transform: createTransform(devotionReminderSchema),
}

// POST devotions/:id/snooze-reminder — {id} = devotion_reminder_id
export const devotion_snoozeReminder_Api = {
    backend: `Route::post('devotions/{id}/snooze-reminder', 'DevotionController@snoozeReminder');`,
    root: API_ROOT_URL,
    path: '/devotions/:id/snooze-reminder',
    method: 'POST',
    paramsFields: [],
    schema: devotionReminderSchema,
    transform: createTransform(devotionReminderSchema),
}

// POST devotions/:id/dismiss-reminder — {id} = devotion_reminder_id
export const devotion_dismissReminder_Api = {
    backend: `Route::post('devotions/{id}/dismiss-reminder', 'DevotionController@dismissReminder');`,
    root: API_ROOT_URL,
    path: '/devotions/:id/dismiss-reminder',
    method: 'POST',
    paramsFields: [],
    schema: devotionReminderSchema,
    transform: createTransform(devotionReminderSchema),
}

// ─── Intention ────────────────────────────────────────────────────────────────

// POST devotions/intention/create — body: { devotion_id, title, content, ... }
export const devotion_createIntention_Api = {
    backend: `Route::post('devotions/intention/create', 'DevotionController@storeIntention');`,
    root: API_ROOT_URL,
    path: '/devotions/intention/create',
    method: 'POST',
    // paramsFields: ['devotion_id', 'title', 'content', 'start_date', 'end_date'],
    schema: devotionIntentionSchema,
    transform: createTransform(devotionIntentionSchema),
}

// POST devotions/intention/:id/edit — {id} = devotion_intention_id
export const devotion_editIntention_Api = {
    backend: `Route::post('devotions/intention/{id}/edit', 'DevotionController@updateIntention');`,
    root: API_ROOT_URL,
    path: '/devotions/intention/:id/edit',
    method: 'POST',
    // paramsFields: ['title', 'content', 'start_date', 'end_date', 'active'],
    schema: devotionIntentionSchema,
    transform: createTransform(devotionIntentionSchema),
}

// POST devotions/intention/:id/delete — {id} = devotion_intention_id
export const devotion_deleteIntention_Api = {
    backend: `Route::post('devotions/intention/{id}/delete', 'DevotionController@destroyIntention');`,
    root: API_ROOT_URL,
    path: '/devotions/intention/:id/delete',
    method: 'POST',
    paramsFields: [],
    schema: devotionIntentionSchema,
    transform: createTransform(devotionIntentionSchema),
}


export const devotion_getChecklists_Api = {
    root: API_ROOT_URL,
    path: '/devotions/:id/checklists',
    method: 'GET',
    paramsFields: ['keyword'],
    schema: devotionChecklistSchema,
    transform: createListTransform(devotionChecklistSchema),
}

export const devotion_createChecklist_Api = {
    root: API_ROOT_URL,
    path: '/devotions/:id/checklists/create',
    method: 'POST',
    schema: devotionChecklistSchema,
    transform: createTransform(devotionChecklistSchema),
}

export const devotion_saveChecklist_Api = {
    root: API_ROOT_URL,
    path: '/devotions/checklists/:checklist_id/save',
    method: 'POST',
    schema: devotionChecklistSchema,
    transform: createTransform(devotionChecklistSchema),
}

export const devotion_editChecklist_Api = {
    root: API_ROOT_URL,
    path: '/devotions/checklist/:checklist_id/edit',
    method: 'POST',
    schema: devotionChecklistSchema,
    transform: createTransform(devotionChecklistSchema),
}

export const devotion_deleteChecklist_Api = {
    root: API_ROOT_URL,
    path: '/devotions/checklist/:checklist_id/delete',
    method: 'POST',
    schema: devotionChecklistSchema,
    transform: createTransform(devotionChecklistSchema),
}